



















































import Vue from 'vue'
import { Component, Watch, Prop, Emit } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppDialog from '@/components/AppDialog.vue'
import { SnackType } from '@/interfaces/snack'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { showErrors, showNotification } from '@/utils/snack'
import { newDocusignEnvelope } from '@/modules/Envelop/gql/envelop.gql'
@Component({
  components: {
    AppTextField,
    AppDialog
  }
})
export default class DocuSignDialog extends Vue {
  @Prop({ type: Boolean }) readonly value!: boolean;
  @Prop({ type: String }) readonly title!: string;
  @Prop({ type: Boolean }) readonly disable!: boolean;
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy;

  showDialog = false;

  docuSignInput: {
    [key: string]: any;
  } = {
    envelopName: ''
  };

  @Watch('value')
  onShowChanged (val: boolean) {
    if (val) {
      this.docuSignInput = {
        envelopName: this.policy.policyName
      }
    }
    this.showDialog = val
  }

  @Emit('post')
  onPostHandler () {
    // do nothing
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  // 创建envelop
  async docuSignConfirm () {
    if (this.validateForm()) {
      const { envelopName } = this.docuSignInput
      try {
        const result = await this.$apollo.mutate({
          mutation: newDocusignEnvelope,
          variables: {
            masterType: 'POLICY',
            masterId: +this.policy.id,
            input: {
              accountId: +this.policy.account.id,
              subject: envelopName
            }
          }
        })
        if (!result.data) {
          showErrors(result.errors)
          return
        }
        showNotification({
          msg: 'Create the new envelop successfully',
          type: SnackType.Success
        })
        this.$router.push({
          name: 'EnvelopDetail',
          params: {
            id: result.data.newDocusignEnvelope.id + '',
            masterId: this.policy.id + '',
            masterType: 'policy',
            type: 'edit'
          }
        })
        this.resetForm()
      } catch (e) {
        showErrors(e.graphQLErrors)
      }
    } else {
      return false
    }
  }

  // 重置表单
  resetForm () {
    this.docuSignInput = {
      envelopName: ''
    }
    this.onSuccess()
  }
  // 表单验证
  validateForm () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
